module.exports = __webpack_public_path__ + "media/青春为祖国歌唱.7fe44ed8.mp4";